import Vue from 'vue'
import Vuex from 'vuex'
import appApiStore from './base/appApi'
import azureAuthStore from './base/azureAuth'
import enterpriseDataApiStore from './base/enterpriseDataApi'
import localSettingStore from './localSettings'
import userDefinedOptionStore from './userDefinedOptions'
import enrolmentRegistrationStore from './enrolmentRegistrations'
import addressStore from './addresses'
import photoStore from './photos'
import collegeCardStore from './collegeCards'
import inductionAttendanceStore from './inductionAttendance'
import withdrawnApplicationStore from './withdrawnApplication'

Vue.use(Vuex)

export default new Vuex.Store({
    
    modules: {
        appApi: appApiStore,
        azureAuth: azureAuthStore,
        enterpriseDataApi: enterpriseDataApiStore,
        localSettings: localSettingStore,
        userDefinedOption: userDefinedOptionStore,
        enrolmentRegistrations: enrolmentRegistrationStore,
        addresses: addressStore,
        photo: photoStore,
        collegeCard: collegeCardStore,
        inductionAttendance: inductionAttendanceStore,
        withdrawnApplication: withdrawnApplicationStore,
    }
    
});
